import script from "./logo.vue?vue&type=script&lang=ts&setup=true"
export * from "./logo.vue?vue&type=script&lang=ts&setup=true"

import "./logo.vue?vue&type=style&index=0&id=810debe6&lang=scss&scoped=true"

import exportComponent from "/Users/chanjack/Desktop/历史/iot-app-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-810debe6"]])

export default __exports__